import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from '../app-config/app-config.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class HomeService {

    constructor(
        private http: HttpClient,
        private appConfig: AppConfigService,
        private router: Router,
        private authService: AuthService,
    ) { }

    getProjects() {
        return this.http.get(this.appConfig.getConfig('server', 'api_endpoint') + '/m1346568/' + this.appConfig.getConfig('server', 'subscription_id') + '/' + this.appConfig.getConfig('server', 'vertical_id'), { headers: this.authService.loadHeaders(false) });
    }

    getProjectGuide(projectId: any) {
        return this.http.get(this.appConfig.getConfig('server', 'api_endpoint') + '/m1306722/' + projectId, { headers: this.authService.loadHeaders(false) });
    }

    getSubGuide(subSectionId: any) {
        return this.http.get(this.appConfig.getConfig('server', 'api_endpoint') + '/m1306716/' + subSectionId, { headers: this.authService.loadHeaders(false) });
    }

    getSubSubGuide(subSubSectionId: any) {
        return this.http.get(this.appConfig.getConfig('server', 'api_endpoint') + '/m1306705/' + subSubSectionId, { headers: this.authService.loadHeaders(false) });
    }
}
